import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueGtag from 'vue-gtag'
import VueObserveVisibility from 'vue-observe-visibility'
import VueRouter from 'vue-router'
import App from './App.vue'
import VueCookies from 'vue-cookies'
import Vuex from 'vuex'
import SimpleVueValidation from 'simple-vue-validator'
import routes from './routes'
import store from './store'

Vue.config.productionTip = false

window.PS = {
  API_BASE_URL: process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://api.powerslide.app',
  appVersion: '0.0.0',
  platform: '',
  SITE_BASE_URL: process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : 'https://powerslide.app',
  user: {}
}

Vue.prototype.PS = window.PS

const axiosInstance = axios.create({
  baseURL: PS.API_BASE_URL,
  withCredentials: true
})

Vue.use(VueAxios, axiosInstance)
Vue.use(VueRouter)
Vue.use(VueCookies)
Vue.use(VueObserveVisibility)
Vue.use(Vuex)
Vue.use(SimpleVueValidation)
Vue.use(require('vue-moment'))

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

Vue.use(VueGtag, {
  config: { id: 'UA-181901091-1' }
}, router)

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
